import { ErrorBoundary } from "../../ErrorBoundary/ErrorBoundary";
import { ConnectWallet } from "../../Header/ConnectWallet/ConnectWallet";
import styleFooter from "./MobileFooter.module.scss";
import { useAppSelector, useIsLoggedSelector } from "../../../../services/hooks.service";
import { LogIn } from "../../Header/LogIn/LogIn";

const MobileFooter = () => {
  const selectedWalletAddress = useAppSelector((state) => state?.user?.activeAddress);
  const mainAddress = useAppSelector((state) => state?.user?.mainAddress);
  const isLogged = useIsLoggedSelector();

  return (
    <>
      <div className={styleFooter.footer}>
        <ErrorBoundary>
          <ConnectWallet />
          {((selectedWalletAddress !== mainAddress) || (selectedWalletAddress && !isLogged)) && <LogIn/>}
        </ErrorBoundary>
      </div>
    </>
  );
};

export { MobileFooter };
